// extracted by mini-css-extract-plugin
module.exports = {"textColor":"CardInfo_textColor__Cfvd_","hoveredTitle":"CardInfo_hoveredTitle__wb0qO"};